import { render, staticRenderFns } from "./treeRight.vue?vue&type=template&id=2b005f25&scoped=true&"
import script from "./treeRight.vue?vue&type=script&lang=js&"
export * from "./treeRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b005f25",
  null
  
)

export default component.exports